import { HeadingStyle } from '../../components'

export default {
  title: 'Heading',
  value: 'heading',
  component: HeadingStyle
}
